<template>
  <div class="po">
    <div class="po__card">
      <div class="po__pin">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
          <circle
            cx="12"
            cy="10"
            r="3"
          />
        </svg>
      </div>
      <div class="po__details">
        <span class="po__name">eKitabu Office</span>
        <span class="po__line">{{ $t('checkout.delivery.officeAddress') }}</span>
        <span class="po__line">{{ $t('checkout.delivery.officeStreet') }}</span>
        <span class="po__city">{{ $t('checkout.delivery.officeCity') }}</span>
        <span class="po__hours">{{ $t('checkout.delivery.officeHours') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "PickupFromOffice",
}
</script>

<style scoped lang="scss">
.po__card {
  display: flex;
  gap: 14px;
  padding: 16px 18px;
  background: $book-grey-lightest;
  border-radius: 12px;
  margin-top: 20px;
}

.po__pin {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: $book-grey-lightest;
  color: $book-grey;
  flex-shrink: 0;
}

.po__details {
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-family: $book-font-body;
}

.po__name {
  font-weight: 700;
  font-size: 0.9375rem;
  color: $book-ink;
}

.po__line {
  font-size: 0.8125rem;
  color: $book-ink;
}

.po__city {
  font-size: 0.8125rem;
  color: $book-ink;
}

.po__hours {
  font-size: 0.75rem;
  color: $book-grey;
  margin-top: 4px;
}
</style>
